<template>
	<div class="kuaidizs">
		
	</div>
</template>

<script>
	export default {
		name: 'Userlist',
		data() {
			return {
			}
		},
		mounted() {
			this.onlist();
		},
		
		methods: {
			onlist() {
				var obj = {};
				this.$axios.post('api/user/kdzs').then(res => {
					if (res.data.code == 0) {
						if(res.data.data.url) {
							window.open(res.data.data.url, '_blank');
						}
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
		}
	}
</script>

<style scoped lang="less">
	.kuaidizs {
		height: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/seller/kuaidizs.vue